import styled from 'styled-components';

/** Row for a title plus origin source pill in air ambulance UI. */
export const OriginSourceTitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

/** Shared pill for displaying an air ambulance origin source. */
export const OriginSourcePill = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.secondaryText};
  background-color: ${({ theme }) => theme.colors.background};
  white-space: nowrap;
  flex-shrink: 0;
  width: fit-content;
`;
